import { format } from 'date-fns';
import { ReportColumn } from '../shared/types';
import { formatMoney } from '@/utils/currency';

export interface ActivityInvoiceRow {
  purchase_invoice: string;
  posting_date: string;
  supplier_name: string;
  items_count: number;
  total_qty: number;
  net_amount: number;
  paid: number;
  outstanding: number;
  status: string;
}

export const activityInvoiceColumns: ReportColumn<ActivityInvoiceRow>[] = [
  { id: 'purchase_invoice', header: 'Purchase Invoice', accessorKey: 'purchase_invoice' },
  {
    id: 'posting_date',
    header: 'Posting Date',
    cell: (r) => (r.posting_date ? format(new Date(r.posting_date), 'd MMM yyyy') : ''),
    exportValue: (r) => r.posting_date,
  },
  { id: 'supplier_name', header: 'Supplier', accessorKey: 'supplier_name' },
  { id: 'items_count', header: 'Items Count', accessorKey: 'items_count', align: 'right' },
  { id: 'total_qty', header: 'Total Qty', accessorKey: 'total_qty', align: 'right' },
  {
    id: 'net_amount',
    header: 'Net Amount',
    align: 'right',
    cell: (r) => `${formatMoney(r.net_amount)}`,
    exportValue: (r) => r.net_amount,
  },
  {
    id: 'paid',
    header: 'Paid',
    align: 'right',
    cell: (r) => `${formatMoney(r.paid)}`,
    exportValue: (r) => r.paid,
  },
  {
    id: 'outstanding',
    header: 'Outstanding',
    align: 'right',
    cell: (r) => `${formatMoney(r.outstanding)}`,
    exportValue: (r) => r.outstanding,
  },
  { id: 'status', header: 'Status', accessorKey: 'status' },
];
